import { ExpertTemplate, ModelKit, User, UserResponse } from 'types/user';

export const transformExpertTemplate = (
  template: ExpertTemplate,
): ModelKit => ({
  id: template.id,
  models: template.expertModes,
  mainModel: template.summaryMode,
  canApply: template.canApply,
});

export const transformUserResponse = (
  userResponse: UserResponse['user'],
): User => {
  const {
    userType: _userType,
    verified: _verified,
    isMarketingSubscribed: _isMarketingSubscribed,
    expertTemplates: _expertTemplates,
    ...userData
  } = userResponse;

  const modelsKit = _expertTemplates.map(transformExpertTemplate);
  return {
    modelsKit,
    ...userData,
  };
};
